import { Headset, LogOut, UserIcon } from "lucide-react";
import { config } from "../../Config";
import { useState } from "react";
import { versionedUrl } from "../../lib/versioning";
import { AtendimentoContent } from "../AtendimentoModal/AtendimentoModal";
import { useAgenteId } from "../../hooks/device/useAgenteId";

const openInNewTab = (url) => {
  const aEl = document.createElement("a");
  aEl.href = url;
  aEl.target = "_blank";
  aEl.click();
};

const loginSocialClaro = () => {
  const configLogin = {
    authEndpoint: config.loginClaro.openIDClaroApi,
    clientId: config.loginClaro.claroClientId,
    redirectUri: config.loginClaro.claroRedirectUri,
    scope: "openid"
  };
  
  const authUrl = `${configLogin.authEndpoint}?client_id=${
    configLogin.clientId
  }&response_type=code&redirect_uri=${encodeURIComponent(
    configLogin.redirectUri
  )}&scope=${encodeURIComponent(configLogin.scope)}`;

  window.location.href = authUrl;
};

const MobileIconButton = ({ src, alt, onClick, children }) => (
  <button
    onClick={onClick}
    className="w-8 h-8 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
    aria-label={alt}
  >
    {src ? (
      <img src={src} alt={alt} className="w-5 h-5" loading="lazy" />
    ) : (
      children
    )}
  </button>
);

const Header = () => {
  const [openModalRedirect, setOpenModalRedirect] = useState(false);
  const { agenteData, hasAgente, logoutAgente } = useAgenteId();
  
return (
  <>
    <div className="relative h-[80px] shadow-lg w-full bg-claro-red py-2 md:py-2 overflow-hidden">
      {/* BG mobile */}
      <div className="absolute inset-0 md:hidden">
        <img
          src={versionedUrl("images/logos/header-mobile-bg.svg")}
          alt=""
          className="h-[5.5rem] w-auto max-w-none object-left-top"
          aria-hidden="true"
          loading="lazy"
        />
      </div>

      <div className="relative w-full max-h-[5rem] max-w-[85rem] mx-auto xl:px-4 px-4 md:px-6 py-2 flex justify-between items-center gap-2">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img
            src={versionedUrl("images/logos/logo_claro.svg")}
            alt="Logo Claro energia"
            className="hidden max-h-[60px] md:block"
            loading="lazy"
          />
        </div>

        {/* MOBILE */}
        <div className="flex items-center gap-3 md:hidden ml-auto">
          {hasAgente ? (
            <>
              {/* Atendimento */}
              <MobileIconButton
                alt="Atendimento"
                onClick={() => setOpenModalRedirect(true)}
              >
                <Headset size={20} color="#fff" />
              </MobileIconButton>

              {/* Separator */}
              <span className="w-px h-6 bg-white/60" aria-hidden="true" />

              {/* User + Agent */}
              <div className="inline-flex items-center gap-3 text-white">
                <UserIcon size={18} />

                <div className="flex flex-col leading-tight text-left">
                  <span className="text-white text-base font-semibold">
                    {agenteData?.nome || "Agente"}
                  </span>

                  <span className="text-white/90 text-xs">
                    Matrícula:{" "}
                    <span className="font-semibold">{agenteData?.matricula}</span>
                  </span>
                </div>
              </div>

              {/* Separator */}
              <span className="w-px h-6 bg-white/60" aria-hidden="true" />

              {/* Exit */}
              <MobileIconButton alt="Sair" onClick={logoutAgente}>
                <LogOut size={20} color="#fff" />
              </MobileIconButton>
            </>
          ) : (
            <>
              <MobileIconButton
                alt="Atendimento"
                onClick={() => setOpenModalRedirect(true)}
              >
                <Headset size={20} color="#fff" />
              </MobileIconButton>
              <MobileIconButton
                alt="Portal do cliente"
                onClick={() => openInNewTab(config.url.urlLoginPortal)}
              >
                <UserIcon size={20} color="#fff" />
              </MobileIconButton>
              <MobileIconButton
                src={versionedUrl("images/logos/icon-lock.svg")}
                alt="Perfil"
                onClick={loginSocialClaro}
              >
              </MobileIconButton>
            </>
          )}
        </div>

        {/* DESKTOP */}
        <div className="lg:px-2 flex gap-2.5 max-md:hidden">
          {hasAgente ? (
            <div className="flex items-center gap-3">
              {/* Atendimento */}
              <button
                onClick={() => setOpenModalRedirect(true)}
                className="h-[33px] px-4 rounded-full bg-transparent border border-white transition-all duration-150 ease-linear text-center text-white text-sm font-normal leading-tight text-nowrap inline-flex items-center gap-2 hover:opacity-70"
                aria-label="Atendimento"
                id="CTA_atendimento"
              >
                <Headset size={16} color="#fff" />
                <span>Atendimento</span>
              </button>

              <span className="w-px h-7 bg-white/60" aria-hidden="true" />

              {/* User + Agent */}
              <div className="inline-flex items-center gap-3 text-white">
                <UserIcon size={18} />

                <div className="flex flex-col leading-tight text-left"> 
                  <span className="text-white text-base font-semibold">
                    {agenteData?.nome || "Agente"}
                  </span>

                  <span className="text-white/90 text-xs">
                    Matrícula:{" "}
                    <span className="font-semibold">{agenteData?.matricula}</span>
                  </span>
                </div>
              </div>

              <span className="w-px h-7 bg-white/60" aria-hidden="true" />

              {/* Exit */}
              <button
                onClick={logoutAgente}
                className="h-[33px] w-[33px] inline-flex items-center justify-center text-white hover:opacity-70 transition-opacity"
                aria-label="Sair"
                id="CTA_exit_agente"
              >
                <LogOut size={18} />
              </button>
            </div>
          ) : (
            <>
              <button
                onClick={() => setOpenModalRedirect(true)}
                className="h-[33px] px-4 rounded-full bg-transparent border border-white transition-all duration-150 ease-linear text-center text-white text-sm font-normal leading-tight text-nowrap justify-start items-center inline-flex gap-3 hover:opacity-70"
                aria-label="Atendimento via WhatsApp"
                id="CTA_atendimento"
              >
                <Headset size={20} color="#fff" />
                <span>Atendimento</span>
              </button>

              <button
                onClick={() => openInNewTab(config.url.urlLoginPortal)}
                className="h-[33px] px-4 rounded-full bg-transparent border border-white transition-all duration-150 ease-linear text-center text-white text-sm font-normal leading-tight text-nowrap justify-start items-center inline-flex gap-3 hover:opacity-70"
                aria-label="Portal do cliente"
                id="CTA_areacliente"
              >
                <UserIcon size={15} />
                <span>Portal do cliente</span>
              </button>

              <button
                onClick={loginSocialClaro}
                className="h-[33px] px-4 rounded-full bg-transparent border border-white transition-all duration-150 ease-linear text-center text-white text-sm font-normal leading-tight text-nowrap justify-start items-center inline-flex gap-3 hover:opacity-70"
                aria-label="Agente Claro"
                id="CTA_agente"
              >
                <img src={versionedUrl("images/logos/icon-lock.svg")} alt={'portal-cliente'} className="w-5 h-5" loading="lazy" />
                <span>Agente Claro</span>
              </button>
            </>
          )}
        </div>
      </div>
    </div>

    <AtendimentoContent
      isOpen={openModalRedirect}
      onClose={() => setOpenModalRedirect(false)}
    />
  </>
);

};

export default Header;
